export enum StatusCode {
  REJECT_OVERSTOCK = 1001,
}
